import {
  Directive,
  HostBinding,
  HostListener,
  computed,
  input,
} from '@angular/core';
import { LoadingDirective } from './loading.directive';

@Directive({
  selector: 'button[nttButton], a[nttButton]',
})
export class NttButton extends LoadingDirective {
  theme = input<
    | 'solid'
    | 'outline'
    | 'ghost'
    | 'error-solid'
    | 'error-outline'
    | 'error-ghost'
    | 'social'
  >('solid');
  size = input<'sm' | 'md' | 'lg' | 'xl'>('md');
  disabled = input(false);

  hostClasses = computed(() =>
    [
      'ntt-button',
      `ntt-button--${this.theme()}`,
      `ntt-button--${this.size()}`,
      this.disabled() ? 'ntt-button--disabled' : '',
      this.loading() ? 'ntt-button-loading' : '',
      this.loading() ? `ntt-button-loading--${this.loadingPosition()}` : '',
    ]
      .filter(Boolean)
      .join(' '),
  );
  protected override _shouldAddDots = false;
  @HostBinding('disabled') get _disabledAttr() {
    return this._isButton ? this.disabled() : undefined;
  }

  @HostBinding('attr.aria-disabled') get _ariaDisabled() {
    return this.disabled() ? 'true' : undefined;
  }

  @HostBinding('attr.role') get _role() {
    return this._isLink ? 'button' : undefined;
  }

  @HostBinding('attr.tabindex') get _tabindex() {
    return this._isLink && this.disabled() ? '-1' : undefined;
  }

  @HostBinding('class') get hostClassesValue() {
    return this.hostClasses();
  }

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    this._elementRef.nativeElement.focus();
    if (this.loading() || this.disabled()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  private get _isButton(): boolean {
    return this._elementRef.nativeElement.tagName === 'BUTTON';
  }

  private get _isLink(): boolean {
    return this._elementRef.nativeElement.tagName === 'A';
  }
}
